import { Send as SendIcon } from '@mui/icons-material'
import React from 'react'
import { useIntl } from 'react-intl'
import { Button } from '../../../../components/Button'

export type InviteIconButtonProps = {
	onClick: () => void
}
const InviteIconButton = ({ onClick }: InviteIconButtonProps) => {
	const { formatMessage } = useIntl()
	return (
		<Button
			key="LoanContactsTable__invite"
			onClick={onClick}
			startIcon={<SendIcon />}
			text={formatMessage({ id: 'global.invite' })}
			variant="text"
			className="dark:!text-white"
		/>
	)
}

export default InviteIconButton
